import { gql, useMutation } from '@apollo/client'
import {
  MutationAnnouncementCreateArgs,
  MutationAnnouncementCreatePayload,
} from 'src/generated'

const MUTATION_ANNOUNCEMENT_CREATE = gql`
  mutation AnnouncementCreate($input: MutationAnnouncementCreateInput!) {
    announcementCreate(input: $input) {
      announcement {
        id
      }
    }
  }
`

const useAnnouncementCreateMutation = () => {
  return useMutation<
    { announcementCreate: MutationAnnouncementCreatePayload },
    MutationAnnouncementCreateArgs
  >(MUTATION_ANNOUNCEMENT_CREATE)
}

export default useAnnouncementCreateMutation
